export default __webpack_public_path__ + "static/media/break28.51d25bbb.jpg";